module.exports = __webpack_public_path__ + "static/media/parkassist.80994bec.png";